import { GetVehicleOdometerResponse } from "../../app/features/vehicles/domain/mro-smartcar.model";

export const getVehicleOdometerResponseMock: GetVehicleOdometerResponse = {
    distance: '10244.53',
};
